module.exports = __webpack_public_path__ + "img/card2-completed.bb6ee1dc.png";